import { render, staticRenderFns } from "./form-torvalla-bil-open.vue?vue&type=template&id=22086820"
import script from "./form-torvalla-bil-open.vue?vue&type=script&lang=js"
export * from "./form-torvalla-bil-open.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports